/* !
 * index.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
	const a = 'is-active';
	const v = 'is-visible';

	const jsonNewsID = () => {
		if(document.querySelectorAll('.js-pickup-id').length) {
			document.querySelectorAll('.js-pickup-id').forEach((element) => {
				const pickupId = element.textContent.trim();
				const container = element.closest('.js-pickup-id-wrap');

				// タグの取得
				fetch(`/ajax/news/pickup_tag/${pickupId}.json`)
				.then(response => response.json())
				.then((data) => {
					const pickupTagList = container.querySelector('.mod-tagList');
					if (pickupTagList && data.rt_bn_pickup_tag_list && data.rt_bn_pickup_tag_list.length) {
						// 既存のタグをクリア
						pickupTagList.innerHTML = '';
						// JSONデータの数だけli要素を作成
						data.rt_bn_pickup_tag_list.forEach((tagInfo) => {
							if (tagInfo.rt_cf_nt_name) {
								const li = document.createElement('li');

							// タグ名に応じたクラスを付与
							const tagName = tagInfo.rt_cf_nt_name.content;
							let tagClass = '_other'; // デフォルト

							if (tagName === 'ニュースリリース') {
								tagClass = '_news';
							} else if (tagName === 'キャンペーン') {
								tagClass = '_campaign';
							} else if (tagName === 'イベント') {
								tagClass = '_event';
							} else if (tagName === 'お知らせ') {
								tagClass = '_notice';
							} else if (tagName === 'その他') {
								tagClass = '_other';
							}

							li.className = `mod-tag ${tagClass}`;
							const span = document.createElement('span');
							span.className = 'js-pickup-tag';
							span.textContent = tagInfo.rt_cf_nt_name.content;
							li.appendChild(span);
								pickupTagList.appendChild(li);
							}
						});
					} else {
						// タグがない場合はタグリスト自体を削除
						pickupTagList.remove();
					}
				})
				.catch(error => {
					console.error('ピックアップタグの取得に失敗しました:', error);
				});
			})
		}
		if(document.querySelectorAll('.js-guide-id').length) {
			document.querySelectorAll('.js-guide-id').forEach((element) => {
				const guideId = element.textContent.trim();
				const container = element.closest('.js-guide-id-wrap');

				// テーマタグの取得
				// fetch(`/ajax/guide_partner/theme_tag/${guideId}.json`)
				// .then(response => response.json())
				// .then((data) => {
				// 	const themeTagList = container.querySelector('.mod-themeTag');
				// 	if (themeTagList && data.rt_bn_reward_theme_tag_list && data.rt_bn_reward_theme_tag_list.length) {
				// 		// 既存のテーマタグをクリア
				// 		themeTagList.innerHTML = '';
				// 		// JSONデータの数だけli要素を作成
				// 		data.rt_bn_reward_theme_tag_list.forEach((themeInfo) => {
				// 			if (themeInfo.rt_cf_nt_name_theme && themeInfo.rt_cf_nt_name_theme_href) {
				// 				const li = document.createElement('li');
				// 				li.innerHTML = `<a href="${themeInfo.rt_cf_nt_name_theme_href.href}" class="js-theme-tag-href">
				// 					<svg class="__icon" aria-hidden="true"><use href="/cnt_common/svg/sprite.svg#tag"></use></svg>
				// 					<span class="__text js-theme-tag">${themeInfo.rt_cf_nt_name_theme.content}</span>
				// 				</a>`;
				// 				themeTagList.appendChild(li);
				// 			}
				// 		});
				// 	}
				// })

				// 除外タグの取得（js-notExcludedクラスがある場合はスキップ）
				if (!element.classList.contains('js-notExcluded')) {
					fetch(`/ajax/reward/exclusion_tag/${guideId}.json`)
					.then(response => response.json())
					.then((data) => {
						if (data.rt_bn_reward_exclusion_tag_list && data.rt_bn_reward_exclusion_tag_list.some((item) => item._key)) {
							// _keyが返っている場合は記事をDOMから削除
							container.remove();
						}
					})
					.catch(error => {
						console.error('除外タグの取得に失敗しました:', error);
					});
				}

				// プランタグの取得
				fetch(`/ajax/guide_partner/plan_tag/${guideId}.json`)
				.then(response => response.json())
				.then((data) => {
					const planTagList = container.querySelector('.mod-planTag');
					if (planTagList && data.rt_bn_reward_plan_tag_list && data.rt_bn_reward_plan_tag_list.length) {
						// 既存のプランタグをクリア
						planTagList.innerHTML = '';
						// JSONデータの数だけli要素を作成
						data.rt_bn_reward_plan_tag_list.forEach((planInfo) => {
							if (planInfo.rt_cf_nt_name_plan && planInfo.rt_cf_nt_name_plan_href) {
								const li = document.createElement('li');
								const a = document.createElement('a');
								a.href = planInfo.rt_cf_nt_name_plan_href.href;
								a.textContent = planInfo.rt_cf_nt_name_plan.content;
								a.className = 'js-plan-tag';
								li.appendChild(a);
								planTagList.appendChild(li);
							}
						});
					}
				})
				.catch(error => {
					console.error('プランタグの取得に失敗しました:', error);
				});
			})
		}
		if(document.querySelectorAll('.js-reward-id').length) {
			// fetch完了前のプレースホルダー（$タグ$）を非表示にする
			document.querySelectorAll('.js-reward-id-wrap').forEach((wrap) => {
				const planTag = wrap.querySelector('.mod-planTag');
				const themeTag = wrap.querySelector('.mod-themeTag');
				if (planTag && planTag.textContent.includes('$')) {
					planTag.innerHTML = '';
				}
				if (themeTag && themeTag.textContent.includes('$')) {
					themeTag.innerHTML = '';
				}
			});

			// Splideクローンにタグ内容を同期する関数
			const syncTagsToClones = (originalSlide) => {
				const ariaLabel = originalSlide.getAttribute('aria-label');
				if (!ariaLabel) return;

				// 最も近いSplideコンテナを特定
				const splideRoot = originalSlide.closest('.splide');
				if (!splideRoot) return;

				// 同じaria-labelを持つクローンを検索
				const clones = splideRoot.querySelectorAll(
					`.splide__slide--clone[aria-label="${ariaLabel}"]`
				);

				clones.forEach(clone => {
					// 対応プランをコピー
					const origPlan = originalSlide.querySelector('.mod-planTag');
					const clonePlan = clone.querySelector('.mod-planTag');
					if (origPlan && clonePlan) {
						clonePlan.innerHTML = origPlan.innerHTML;
					}

					// テーマタグをコピー
					const origTheme = originalSlide.querySelector('.mod-themeTag');
					const cloneTheme = clone.querySelector('.mod-themeTag');
					if (origTheme && cloneTheme) {
						cloneTheme.innerHTML = origTheme.innerHTML;
					}
				});
			};

			document.querySelectorAll('.js-reward-id').forEach((element) => {
				const rewardId = element.textContent.trim();
				const container = element.closest('.js-reward-id-wrap');

				// クローンスライド内の要素はスキップ（オリジナルからの同期で対応）
				if (container && container.closest('.splide__slide--clone')) return;

				// 除外タグの取得（js-notExcludedクラスがある場合はスキップ）
				if (!element.classList.contains('js-notExcluded')) {
					fetch(`/ajax/reward/exclusion_tag/${rewardId}.json`)
					.then(response => response.json())
					.then((data) => {
						if (data.rt_bn_reward_exclusion_tag_list && data.rt_bn_reward_exclusion_tag_list.some((item) => item._key)) {
							// _keyが返っている場合は記事をDOMから削除
							container.remove();
						}
					})
					.catch(error => {
						console.error('除外タグの取得に失敗しました:', error);
					});
				}

				// テーマタグの取得
				fetch(`/ajax/reward/theme_tag/${rewardId}.json`)
				.then(response => response.json())
				.then((data) => {
					const themeTagList = container.querySelector('.mod-themeTag');
					if (themeTagList && data.rt_bn_reward_theme_tag_list && data.rt_bn_reward_theme_tag_list.length) {
						// 既存のテーマタグをクリア
						themeTagList.innerHTML = '';
						// JSONデータの数だけli要素を作成
						data.rt_bn_reward_theme_tag_list.forEach((themeInfo) => {
							if (themeInfo.rt_cf_nt_name_theme && themeInfo.rt_cf_nt_name_theme_href) {
								const li = document.createElement('li');
								li.innerHTML = `<a href="${themeInfo.rt_cf_nt_name_theme_href.href}" class="js-theme-tag-href">
									<svg class="__icon" aria-hidden="true"><use href="/cnt_common/svg/sprite.svg#tag"></use></svg>
									<span class="__text js-theme-tag">${themeInfo.rt_cf_nt_name_theme.content}</span>
								</a>`;
								themeTagList.appendChild(li);
							}
						});
					}
					// クローンにも同期
					syncTagsToClones(container);
				})

				// プランタグの取得
				fetch(`/ajax/reward/plan_tag/${rewardId}.json`)
				.then(response => response.json())
				.then((data) => {
					const planTagList = container.querySelector('.mod-planTag');
					if (planTagList && data.rt_bn_reward_plan_tag_list && data.rt_bn_reward_plan_tag_list.length) {
						// 既存のプランタグをクリア
						planTagList.innerHTML = '';
						// JSONデータの数だけli要素を作成
						data.rt_bn_reward_plan_tag_list.forEach((planInfo) => {
							if (planInfo.rt_cf_nt_name_plan && planInfo.rt_cf_nt_name_plan_href) {
								const li = document.createElement('li');
								const a = document.createElement('a');
								a.href = planInfo.rt_cf_nt_name_plan_href.href;
								a.textContent = planInfo.rt_cf_nt_name_plan.content;
								a.className = 'js-plan-tag';
								li.appendChild(a);
								planTagList.appendChild(li);
							}
						});
					}
					// クローンにも同期
					syncTagsToClones(container);
				})
				.catch(error => {
					console.error('プランタグの取得に失敗しました:', error);
				});
			})
		}
	};

	const checkSubmit = () => {
		const form = document.querySelector('.js-check-submit');
		if (form) {
			// 前回送信後のスクロール処理（ブラウザのネイティブアンカースクロールとの競合を回避）
			const targetId = sessionStorage.getItem('js-check-submit-scroll');
			if (targetId) {
				sessionStorage.removeItem('js-check-submit-scroll');
				const target = document.getElementById(targetId);
				if (target) {
					const doScroll = () => {
						const offset = FUNCTIONS.va.window.width < FUNCTIONS.va.device.sp
							? FUNCTIONS.va.header.sp
							: FUNCTIONS.va.header.desktop;
						const top = target.getBoundingClientRect().top + window.scrollY - offset;
						window.scrollTo({ top, behavior: 'smooth' });
					};
					'complete' === document.readyState ? doScroll() : window.addEventListener('load', doScroll);
				}
			}

			const checkboxes = form.querySelectorAll('input[type="checkbox"]');
			checkboxes.forEach(function(checkbox) {
				checkbox.addEventListener('change', function() {
					// ハッシュをURLに含めずsessionStorageでスクロール先を伝達
					sessionStorage.setItem('js-check-submit-scroll', 'js-check-submit-target');
					form.action = form.action.split('#')[0];
					form.submit();
				});
			});
		}
	};

	// ＝＝＝＝ ↑↑ FUNCTIONS ↑↑ ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝

	const jsonFUNCTIONS = () => {
		jsonNewsID();
		checkSubmit();
	};

	(FUNCTIONS.localDecision()) ? document.addEventListener('localincludeLoaded', () => { jsonFUNCTIONS(); }) : jsonFUNCTIONS();

})(window.FUNCTIONS);
